/** Fetch time remains immutable; displayed age advances even when the payload does not. */
export function feedAge(fetchedAt: string | null, reportedAge = 0, now = Date.now()): number {
  const time = fetchedAt ? Date.parse(fetchedAt) : NaN;
  return Number.isFinite(time) ? Math.max(reportedAge, Math.max(0, Math.floor((now - time) / 60_000))) : reportedAge;
}
